// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___1UDix","checkWrapper":"styles__checkWrapper___1PUry","checkIcon":"styles__checkIcon___24AKM","titleReady":"styles__titleReady___1jQjv"};